import styled from "styled-components";
import { Logo } from "../login/login.styles";
import { Link } from "react-router-dom";
import BurgerIcon from "../../assets/icons/burger.svg";
type Pin = {
  isPinned: boolean;
};
type SideNav = {
  isSideNavOpen: boolean;
};
export const SideBar = styled.nav<Pin & SideNav>`
  height: 100vh;
  display: ${({ isPinned }) => (isPinned ? "block" : "none")};
  width: ${({ isPinned }) => (isPinned ? "300px" : "80px")};
  padding: 2rem 1rem;
  /* background-color: ${({ theme: { colors } }) => colors.black}; */
  background-color: var(--item-background-color);
  transition:
    width 0.3s ease,
    left 0.5s ease,
    right 0.5s ease;
  transition-delay: 0.6s, 0s, 0s;
  overflow: hidden;
  position: fixed;
  z-index: ${({ isPinned }) => (isPinned ? 100 : 99999)};
  left: 0;
  top: 0;

  &:hover {
    width: 300px;
    transition-delay: 0s;
  }
  &:hover button {
    opacity: 1;
    pointer-events: all;
  }
  &:hover span {
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);
    transition-delay: 0.3s;
  }
  &:hover h4 {
    clip-path: polygon(100% 0, 0 0, 0 100%, 100% 100%);
    transition-delay: 0.3s;
  }
  &:hover img {
    position: relative;
    bottom: 0;
  }
  body[lang="ar"] & {
    top: 0;
    right: 0;
    left: unset;
  }
  @media (max-width: 768px) {
    position: fixed;
    z-index: 100;
    top: 0;
    left: ${({ isSideNavOpen }) => (isSideNavOpen ? "0" : "-100%")};
    body[lang="ar"] & {
      top: 0;
      right: ${({ isSideNavOpen }) => (isSideNavOpen ? "0" : "-100%")};
      left: unset;
    }
  }
`;

export const LogoIcon = styled(Logo)`
  width: 48px;
  height: 48px;
`;
export const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
`;
export const PinButton = styled.button<Pin>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ isPinned }) =>
    isPinned ? "var(--secondary-background-color)" : "transparent"};
  opacity: ${({ isPinned }) => (isPinned ? "1" : "0")};
  // pointer-events: ${({ isPinned }) => (isPinned ? "all" : "none")};
  transition: opacity 0.3s ease;
  display: grid;
  place-items: center;
`;
export const NavHeader = styled.h4<Pin>`
  /* color: ${({ theme: { colors } }) => colors.gray400}; */
  color: var(--text-color);
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 1.5rem;
  clip-path: ${({ isPinned }) =>
    isPinned
      ? "polygon(100% 0, 0 0, 0 100%, 100% 100%)"
      : "polygon(100% 0, 0 0, 0 0, 100% 0)"};
  transition: clip-path 0.3s ease;
  transition-delay: 0.6s;
`;
export const NavLink = styled(Link)`
  display: flex;
  width: 100%;
  margin-bottom: 0.5em;
  align-items: center;
  padding: 0.5rem;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: var(--secondary-background-color);
  }
`;
export const NavLinkIcon = styled.img`
  width: 20px;
  height: 20px;
  color: white;
  body[lang="ar"] & {
    margin-left: 1rem;
  }
  body[lang="en"] & {
    margin-right: 1rem;
  }
`;
export const NavLinkText = styled.span<Pin>`
  /* color: ${({ theme: { colors } }) => colors.white}; */
  color: var(--text-color);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  clip-path: ${({ isPinned }) =>
    isPinned
      ? "polygon(0 0, 100% 0%, 100% 100%, 0% 100%)"
      : "polygon(0 0, 0 0, 0 100%, 0% 100%)"};
  transition: all 0.3s ease;
  transition-delay: 0.3s;
  bottom: 30px;
`;
export const LinksGroup = styled.div`
  margin-bottom: 2rem;
`;
export const DashboardContainer = styled.main<Pin>`
  display: flex;
  min-height: 100vh;
  padding: 70px 3rem 1rem
    ${({ isPinned }) => (isPinned ? "calc(0px + 3rem)" : "calc(0px + 3rem)")};
  body[lang="ar"] & {
    padding: 100px
      ${({ isPinned }) =>
        isPinned ? "calc(250px + 3rem)" : "calc(80px + 3rem)"}
      1rem 3rem;
  }
  @media (max-width: 768px) {
    padding: 100px 2rem 1rem 2rem !important;
  }
  @media (max-width: 425px) {
    padding: 100px 1rem 1rem 1rem !important;
  }
  transition: padding 0.3s ease;
`;
export const DashboardContent = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const UpperNavContainer = styled.nav<Pin>`
  /* background-color: ${({ theme: { colors } }) => colors.white}; */
  background-color: var(--secondary-item-background-color);
  height: 60px;
  position: fixed;
  top: 0;
  transition: width 0.3s ease;
  left: 50%;
  transform: translateX(-50%);
  width: ${({ isPinned }) =>
    isPinned ? "calc(100% - 250px - 6rem)" : "calc(100% - 80px - 6rem)"};
  body[lang="ar"] & {
    top: 0;
    // left: 3rem;
    right: unset;
  }
  z-index: 99;
  border-radius: 8px;
  margin: 1rem auto;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  align-items: center;
  padding: 1rem;
  @media (max-width: 768px) {
    width: calc(100% - 4rem);
    right: 2rem !important;
  }
  @media (max-width: 425px) {
    width: calc(100% - 2rem);
    right: 1rem !important;
  }
`;
export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
export const AdminImg = styled.img`
  width: 40px;
  height: 40px;
  cursor: pointer;
  object-fit: contain;
  border-radius: 50%;
`;
export const AdminName = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 16px */
`;
export const IconsContainer = styled.div`
  display: flex;
  gap: 1.6rem;
  justify-content: space-between;
  align-items: center;
`;
export const Icon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
export const Burger = styled(Icon).attrs({ src: BurgerIcon })`
  display: none;
  @media (max-width: 768px) {
    display: inline;
  }
`;
export const ExitButton = styled.button`
  width: 32px;
  height: 32px;
  /* color: ${({ theme: { colors } }) => colors.white}; */
  color: var(--text-color);
  background-color: transparent;
`;
